export default __webpack_public_path__ + "static/b3-8dc24dfa92695339ca264beb4a774a31.png";